export async function getNetStatus(): Promise<TNetStatus> {
  // const connection = navigator.connection
  const isConnect = navigator?.onLine || 'unkown'
  // const { effectiveType = 'unkown' } = connection || {}
  return { isConnect, networkType: 'unkown', isWifi: true }
}
